<template>
  <b-modal
    :active.sync="active_"
    has-modal-card
    class="import-modal"
    @close="close"
  >
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title has-text-weight-bold">Importer</p>
        <button type="button" class="delete" @click.prevent="close" />
      </header>
      <section class="modal-card-body">
        <b-field label="CSV File">
          <b-upload v-model="file" class="file-label">
            <span class="file-cta">
              <b-icon class="file-icon" icon="upload"></b-icon>
              <span class="file-label">Select a file</span>
            </span>
            <span class="file-name" v-if="file">
              {{ file.name }}
            </span>
          </b-upload>
        </b-field>
      </section>
      <footer
        class="modal-card-foot"
        style="display: flex; justify-content: space-between"
      >
        <div>
          <p v-if="fileData">
            {{ fileDataProcessed }}/{{ fileData.length - 1 }} PROCESSED
          </p>
        </div>
        <b-button
          v-if="fileData && fileData.length - 1 == fileDataProcessed"
          @click="downloadResult"
        >
          Download Result
        </b-button>
        <b-button
          v-else
          :disabled="!file"
          :loading="loading"
          @click="onImportClaimLines"
        >
          Import Claim Lines
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import { OrderOperationClaimLineService } from "@/services/orderOperationClaimLine.service";

export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    active_: false,
    file: null,
    fileReader: null,
    fileData: null,
    fileDataProcessed: 0,
    fileDataStatus: [],
    fileDataError: [],
    fileReady: false,
    errors: {},
    loading: false,
  }),
  mounted() {
    this.fileReader = new FileReader();
    this.fileReader.onload = () => {
      let data = this.fileReader.result;
      if (data.search("\r\n") > -1) {
        data = data.split("\r\n");
      } else {
        data = data.split("\n");
      }
      // data.pop();
      data = data.map((row) => row.split(",").map((d) => d.replace(/"/g, "")));
      this.fileData = data;
      this.fileReady = true;
    };
  },
  watch: {
    active(active) {
      this.active_ = active;
    },
    active_(active) {
      this.$emit("update:active", active);
    },
    // File ready triggers import
    fileReady() {
      if (this.fileReady) {
        this.importClaimLines();
      }
    },
  },
  methods: {
    close() {
      this.file = null;
      this.fileData = null;
      this.fileReady = false;
      this.loading = false;
      this.active_ = false;
    },
    onImportClaimLines() {
      this.loading = true;
      console.log("Loading", this.loading);
      this.fileDataProcessed = 0;
      this.fileDataStatus = [];
      this.fileDataError = [];
      this.fileReady = false;
      this.fileReader.readAsText(this.file);
    },
    async importClaimLines() {
      this.$store.state.apiErrorsVisible = false;
      const indexes = {
        orderNumber: this.getFileDataColumnIndex("order_number"),
        activityNumber: this.getFileDataColumnIndex("activity_number"),
        rateCode: this.getFileDataColumnIndex("rate_code"),
        quantity: this.getFileDataColumnIndex("quantity"),
        referenceCode: this.getFileDataColumnIndex("reference_code"),
        notes: this.getFileDataColumnIndex("notes"),
      };
      const indexesRequired = [
        "orderNumber",
        "activityNumber",
        "rateCode",
        "quantity",
      ];
      console.log("indexes", Object.values(indexes));
      console.log("indexes", indexes);
      console.log("fileData", this.fileData);
      if (
        Object.entries(indexes)
          .filter(([k, v]) => indexesRequired.includes(k))
          .every(([k, v]) => v > -1)
      ) {
        let data = JSON.parse(JSON.stringify(this.fileData));
        // Remove header
        data.splice(0, 1);
        // Process claim lines by batch
        let chunk = [];
        while ((chunk = data.splice(0, 3)) && chunk.length) {
          const requests = chunk.map(async (v) => {
            try {
              // Convert line to request payload
              const res = await this.getClaimLineDataIds({
                order_orderId: v[indexes.orderNumber],
                operation_operationId: v[indexes.activityNumber],
                rate_code: v[indexes.rateCode],
                wbs_code_code: v[indexes.referenceCode] || undefined,
              });
              // Prevent calling create endpoint with invalid required data ids
              if (!res.operation_operationId) {
                throw new Error(
                  "No order operation found with the submitted combination of order and activity numbers"
                );
              }
              // Convert response to request payload
              await this.createClaimLine(res.operation_operationId, {
                orderOperationClaimServiceId: res.rate_code,
                quantity: v[indexes.quantity],
                wbsCodeId: res.wbs_code_code || undefined,
                details: v[indexes.notes] || undefined,
              });
              return { success: true };
            } catch (err) {
              return { success: false, message: err.message };
            } finally {
              this.fileDataProcessed++;
            }
          });
          await Promise.all(requests).then((v) => {
            v.forEach((res) => {
              this.fileDataStatus.push(res.success ? "pass" : "fail");
              this.fileDataError.push(res.message ? `"${res.message}"` : "");
            });
          });
        }
      } else {
        this.$buefy.toast.open({
          message: "Missing required headers.",
          type: "is-danger",
          position: "is-top-right",
        });
      }
      this.loading = false;
      this.$store.state.apiErrorsVisible = true;
    },
    getFileDataColumnIndex(column) {
      return this.fileData[0].findIndex(
        (v) => column == v.trim().replace(" ", "_").toLowerCase()
      );
    },
    getClaimLineDataIds(data) {
      return OrderOperationClaimLineService.mappedIds(data);
    },
    createClaimLine(operationId, data) {
      return OrderOperationClaimLineService.create(operationId, data);
    },
    downloadResult() {
      let data = this.fileData;
      data = data
        .map((v, i) => {
          // Header
          if (i == 0) {
            v.push("Status");
            v.push("Error");
          } else {
            v.push(this.fileDataStatus[i - 1]);
            v.push(this.fileDataError[i - 1]);
          }
          return v;
        })
        .map((v) => v.join(","));
      data = data.join("\r\n");
      let blob = new Blob([data], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      const random = (Math.random() + 1).toString(36).substring(7);
      link.setAttribute("download", `import_result_${random}.csv`);
      document.body.appendChild(link);
      link.click();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ClaimLine/ClaimLineImporter.vue